import { Form, Card, Space } from "antd";
import SuppliersTable from "./components/SuppliersTable";
import SupplierFiltersForm from "./components/SupplierFiltersForm";
import useSupplierList from "./domainModel/supplierList";
import { useEffect } from "react";
const DefaultFormData = {
  supplierName: "",
  contactName: "",
  status: "",
};

export default function SupplierManagement() {
  const [supplierlistModel] = useSupplierList();
  const [filtersFrom] = Form.useForm();
  const search = () => {
    supplierlistModel.getList({
      ...filtersFrom.getFieldsValue(),
    });
  };
  useEffect(() => {
    filtersFrom.submit();
  }, [filtersFrom]);
  return (
    <Space
      direction="vertical"
      style={{ width: "100%", display: "flex", flexDirection: "column" }}
    >
      <Card>
        <SupplierFiltersForm
          form={filtersFrom}
          onFormDataChange={search}
          initialValues={DefaultFormData}
          onAddSupplierSuccess={() => supplierlistModel.emit("onSupplierAdded")}
        />
      </Card>
      <Card style={{ height: "100%", flexGrow: 1 }}>
        <SuppliersTable
          suppliers={supplierlistModel.list}
          onEditSupplierFinish={() =>
            supplierlistModel.emit("onSupplierModified")
          }
          loading={supplierlistModel.listLoading}
          pager={supplierlistModel.pager}
        />
      </Card>
    </Space>
  );
}
